// Libs
import React from "react";

import { DropdownMenu } from "./DropdownContentStyle";

const DropdownContent = ({ children, position, setActive }) => {
  return <DropdownMenu position={position}>{children}</DropdownMenu>;
};

export default DropdownContent;



// WEBPACK FOOTER //
// ./src/newDropshipperApp/spocketUI/components/dropdown/DropdownContent.js